module.exports = __webpack_public_path__ + "static/img/13.7e66a69.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/3/4/sp/13.png
// module id = MMdU
// module chunks = 0